import CookieStorage from './cookies-storage';
import StorageDetector from './storage-detector';

export const LOCAL_STORAGE_ENABLED = StorageDetector.isEnabled('localStorage');

export const STORAGE = LOCAL_STORAGE_ENABLED ? localStorage : new CookieStorage();
